export default "__VITE_ASSET__Cls9Jkg5__"